<template>
    <div>
        <div class='footer-column-title'>
            Company
        </div>
        <div class='footer-column-links'>
            <div @click="onClickLink('company/why-itim')"><a class="footer-link">Why Itim</a></div>
            <div @click="onClickLink('company/about')"><a class="footer-link">About</a></div>
            <div @click="onClickLink('compant/contact')"><a class="footer-link">Contact</a></div>
        </div>
    </div>
</template>
<script>
export default {
    methods: {
        onClickLink(page, external = false) {
            if(external) {
                window.open(page, '_blank');
            } else {
                this.$router.push(`/${page}`);
            }
        }
    }
}
</script>